import { BrowserRouter } from 'react-router-dom';
import { useEffect } from 'react';
import { StatusModalProvider } from '@shared/context/StatusModalContext';
import { AppRouter } from './router/AppRouter';
import { AppProvider } from './providers/AppProvider';
import { useStoreDisplayName } from '@core/tenant/useStoreDisplayName';

const DocumentTitle = () => {
  const displayName = useStoreDisplayName();
  useEffect(() => {
    document.title = displayName;
  }, [displayName]);
  return null;
};

export const App = () => {
  return (
    <AppProvider>
      <DocumentTitle />
      <BrowserRouter
        future={{
          v7_startTransition: true,
          v7_relativeSplatPath: true,
        }}
      >
        <StatusModalProvider>
          <AppRouter />
        </StatusModalProvider>
      </BrowserRouter>
    </AppProvider>
  );
};

